import { createFileRoute } from "@tanstack/react-router"
import { getStoryMeta } from "@/content/stories"
import { StoryPage } from "@/content"

export const Route = createFileRoute("/(public)/stories/$slug")({
  component: RouteComponent,
  head: ({ params: { slug } }) => ({
    meta: getStoryMeta(slug),
  }),
})

function RouteComponent() {
  const { slug } = Route.useParams()

  return <StoryPage slug={slug} />
}
